'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
  AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
  Loading = require('components/Commons/Loading/Loading'),
  NumberUtils = require('utils/NumberUtils'),
  NavigationUtils = require('utils/NavigationUtils'),
  PositionUtils = require('utils/PositionUtils'),
  {delay} = require('lodash/function'),
  Notification = require('components/Notification/Notification'),
  ContentUtils = require('utils/ContentUtils'),
  AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
  AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
  FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
  FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
  FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
  Constants = require('constants/AppConstants'),
  Authentication = require('services/Security').Authentication,
  InventoryStore = require('stores/InventoryStore'),
  BeerStyleStore = require('stores/BeerStyleStore'),
  Stamps = require('components/Commons/Stamps/Stamps'),
  Stamp = require('components/Commons/Stamps/Stamp/Stamp'),
  DashboardServiceCache = require('services/DashboardServiceCache'),
  {map, find, filter} = require('lodash/collection'),
  get = require('lodash/object').get,
  ga = require('react-ga'),
  {orderBy} = require('lodash/collection'),
  {Navigation} = require('react-router'),
  CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const AMOUNT_DECIMALS = 4;

let ProductsAdmin = React.createClass({displayName: "ProductsAdmin",
  mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

  getInitialState() {
    return {
      selectedProduct: null,
      isEditMode: false
    };
  },

  componentDidMount() {
    this.fetchProducts();
    ga.pageview('/products-admin');
  },

  fetchProducts() {
    const self = this;
    InventoryStore.fetchProducts(function (products) {
      InventoryStore.fetchLocation(function (locations) {
        BeerStyleStore.fetchStyleBeers(function (beerStyles) {
          InventoryStore.fetchIcons(function (response) {
            const icons = ContentUtils.formatApplicantIcons(response.icons, response.iconsFromApplicant);
            self.setState({
              locations: ContentUtils.filterEnable(locations),
              products: self._hydrateProducts(products, icons),
              productSelectedId: NavigationUtils.getQueryParam('productSelectedId'),
              beerStyles,
              isEditMode: ContentUtils.isNotNullOrUndefined(NavigationUtils.getQueryParam('productSelectedId')),
              unit: DashboardServiceCache.getCurrentUnitTank()
            }, self._onFinishRenderingFetchProducts);
          });
        });
      });
    });
  },

  _onFinishRenderingFetchProducts() {
    const {productSelectedId, products} = this.state;
    const haveProductSelectedTable = !!productSelectedId;

    if (haveProductSelectedTable) {
      const self = this;
      this.setState({
        selectedProduct: find(products, product => get(product, 'id') === +productSelectedId)
      }, () => {
        self._setPositionScrollById.bind(self)(productSelectedId);
      });
    }
  },

  _addQueryParamWithRowSelected(product, lastRowScrollPosition) {
    this.transitionTo(
      `/products`,
      {},
      {
        productSelectedId: get(product, 'id')
      }
    );
    // Is needed to force scroll position again
    // in order to avoid jumping scroll behavior
    delay(() => {
      this.getDOMNode().querySelector(
        '.mui-body-table'
      ).scrollTop = lastRowScrollPosition;
    }, 1);
  },

  _setPositionScrollById(productSelectedId) {
    const tableEl = this.getDOMNode().querySelector('.mui-body-table');
    const rowEl = tableEl.querySelector(`tr[data-row-id="${productSelectedId}"]`);
    const positionTopRowEl = PositionUtils.elementScrollTop(rowEl);
    tableEl.scrollTop = positionTopRowEl;
  },

  _hydrateProducts(products, iconsFull) {
    return map(products, product => {
      product.volumeWithUnit =
        NumberUtils.formatDecimal(product.volume) +
        ' ' +
        DashboardServiceCache.getCurrentUnitTank();

      if (product && ContentUtils.isNotEmptyArray(product.iconsId)) {
        product.iconsFull = map(product.iconsId, iconId =>
          find(iconsFull, iconFull => iconFull.id === iconId)
        );
      }

      return product;
    });
  },

  _onDeleteProduct(product, onSuccess, onFailure) {
    CustomDialog.showWarningConfirmation(
      t('warning'),
      t('product_admin_general_warning_confirm_delete'),
      () => {
        InventoryStore.deleteProduct(product, onSuccess, onFailure);
      }
    );
  },

  _onChangeProducts(product, onSuccess, onFailure) {
    InventoryStore.changeProduct(product, onSuccess, onFailure);
  },

  _onAddProduct(product, onSuccess, onFailure) {
    const {products} = this.state;
    const codeProduct = ContentUtils.retrieveNextItemCode(
      products,
      product,
      Constants.MODULE_PRODUCT_ACRONYM
    );
    product.code = codeProduct;
    InventoryStore.addProduct(product, onSuccess, onFailure);
  },

  _onDuplicateProduct(product, onSuccess, onFailure) {
    const {products} = this.state;
    const codeProduct = ContentUtils.retrieveNextItemCode(
      products,
      product,
      Constants.MODULE_PRODUCT_ACRONYM
    );
    product.code = codeProduct;
    InventoryStore.duplicateProduct(product, onSuccess, onFailure);
  },

  _onRowSelection(product,
                  itemIndex,
                  lastRowScrollPosition,
                  headerActiveFilters) {
    if (product && product.beerStyle) {
      product.beerStyleName = product.beerStyle.name;
    }
    this.setState(
      {
        selectedProduct: product,
        isEditMode: !!product,
        headerActiveFilters
      },
      () => {
        // stay the position of the scroll after row select when
        // the offset is outside of initial viewport page.
        this.getDOMNode().querySelector(
          '.mui-body-table'
        ).scrollTop = lastRowScrollPosition;

        this._addQueryParamWithRowSelected(product, lastRowScrollPosition);
      }
    );
  },

  _onCancel() {
    this.transitionTo('/products');
    this.setState({
      selectedProduct: null,
      selectedProductId: null,
      isEditMode: false
    });
  },

  _goTo(page) {
    if (page) {
      this.transitionTo(
        `/products/:productId/:page`,
        {
          productId: get(this.state, 'selectedProduct.id'),
          page
        },
        {
          productName: get(this.state, 'selectedProduct.name'),
          productSelectedId: get(this.state, 'selectedProduct.id'),
          beerStyle: get(
            this.state,
            'selectedProduct.beerStyle.name'
          ),
          volume: get(this.state, 'selectedProduct.volume'),
          unit: get(this.state, 'selectedProduct.unit')
        }
      );
    }
  },

  _getBreadcrumbLinks() {
    return [
      {
        displayName: t('product_admin_general_title')
      }
    ];
  },

  _getStampsIcons(iconsFull) {
    return (
      React.createElement(Stamps, null, 
        map(iconsFull, stamp => React.createElement(Stamp, {classNameIcon: get(stamp, 'iconDetail.iconClassName')}))
      )
    );
  },

  _onEnterPress() {
    if (this.onEnterKeyDown) {
      this.onEnterKeyDown();
    }
  },

  _onDuplicate(contextHolder) {
    // get value from all fields
    let currentSelectedItem = contextHolder.getItem();

    // override with duplicate label
    currentSelectedItem.name = ContentUtils.formatDuplicateName(currentSelectedItem.name);

    // add date to duplicate and remove id in order
    // to generate a new one like new item
    currentSelectedItem.duplicatedId = NavigationUtils.getQueryParam('productSelectedId');
    currentSelectedItem.id = null;
    currentSelectedItem.isDuplicated = true;

    this._onDuplicateProduct(currentSelectedItem, () => {
      Notification.show(t('product_admin_general_suplicated_success'), 'success');
      this.fetchProducts();
    });
  },

  _addEnterKeyDown(onEnterKeyDown) {
    this.onEnterKeyDown = onEnterKeyDown;
  },

  _getWrapperColor(item) {
    const isMenuItemUsed = item.payload !== undefined;
    let beerStyle;

    if (isMenuItemUsed) {
      beerStyle = item.itemModel;
    } else {
      beerStyle = item;
    }

    return (
      React.createElement("div", null, 
                React.createElement("span", {
                  className: "text-center", 
                  style: {
                    height: '20px',
                    borderRadius: '22px',
                    boxShadow: (beerStyle ? '1px 2px 4px 0px gray' : '0 0 0 0 #fff'),
                    backgroundColor: get(beerStyle, 'color'),
                    border: 'solid 0px black',
                    padding: '10px 17px',
                    left: '0',
                    position: 'relative',
                    opacity: '.6'
                  }}
                ), 
        React.createElement("span", {style: {paddingLeft: '10px'}}, get(beerStyle, 'name') || get(item, 'text'))
      )
    );
  },

  render() {
    if (!this.state.products || !this.state.beerStyles) {
      return React.createElement(Loading, null);
    } else {
      const CATEGORIES_TEXTS = Constants.getProductCategoryMapping(t);
      const PRODUCT_CATEGORIES = Constants.PRODUCT_CATEGORY.map(category => ({category: category, displayText: Constants.getProductCategoryMapping(t)[category]}));
      const messages = {
        changeSuccessMessage: t('product_admin_general_change_success'),
        changeFailureMessage: t('product_admin_general_change_failure'),
        deleteSuccessMessage: t('product_admin_general_delete_success'),
        addSuccessMessage: t('product_admin_general_add_success'),
        addFailureMessage: t('product_admin_general_add_failure')
      };

      let contextHolder = this.getContextHolderInstance();

      let {selectedProduct, products, isEditMode} = this.state;

      if (products && products.length) {
        products = products.map(item => {
          item.displayCategory = CATEGORIES_TEXTS[item.category];
          return item;
        });
      }

      const currentSelectedCategory = selectedProduct && selectedProduct.category
        ? CATEGORIES_TEXTS[selectedProduct.category]
        : '';

      const currentSelectedCategoryValue = currentSelectedCategory
        ? Object.assign({}, selectedProduct, {displayText: currentSelectedCategory})
        : selectedProduct;

      const unitName = this.state.unit ? this.state.unit : '';
      const unitNameWhitParenthesis = unitName ? `(${unitName})` : '';
      const additionalButtons = [
        {
          type: 'CHANGE',
          permission: 'ICON_SHOW',
          el: (
            React.createElement(FormGroupButton, {
              label: t('product_admin_general_set_icons'), 
              icon: "subdirectory_arrow_right", 
              type: "icon", 
              onClick: this._goTo.bind(this, 'icons')}
            )
          )
        },
        {
          type: 'CHANGE',
          permission: 'ITEMS_SUBSTRACTION_SHOW',
          el: (
            React.createElement(FormGroupButton, {
              label: t('product_admin_general_set_substraction_item'), 
              icon: "subdirectory_arrow_right", 
              type: "icon", 
              onClick: this._goTo.bind(this, 'items')}
            )
          )
        },
        {
          type: 'CHANGE',
          permission: 'ITEMS_ADDITION_SHOW',
          el: (
            React.createElement(FormGroupButton, {
              label: t('product_admin_general_set_addition_item'), 
              icon: "subdirectory_arrow_right", 
              type: "icon", 
              onClick: this._goTo.bind(this, 'items-addition')}
            )
          )
        },
        {
          type: 'CHANGE',
          permission: 'DUPLICATE_SHOW',
          el: (
            React.createElement(FormGroupButton, {
              label: t('product_admin_general_duplicated'), 
              icon: "content_copy", 
              type: "icon", 
              onClick: this._onDuplicate.bind(this, contextHolder)}
            )
          )
        }
      ];
      const sortedBeerStyle = orderBy(this.state.beerStyles, 'name');
      let formFieldsEl = [
        React.createElement(FormGroupTextfield, {
          operationsHolder: contextHolder, 
          readerAttribute: "name", 
          isRelaxedText: true, 
          name: t('name'), 
          value: selectedProduct, 
          label: t('product_admin_general_column_name'), 
          isEditMode: isEditMode, 
          onEnter: this._onEnterPress}
        ),
        React.createElement(FormGroupTextFieldSuggested, {
          operationsHolder: contextHolder, 
          items: isEditMode ? sortedBeerStyle : filterBeerStyleEnable(sortedBeerStyle), 
          readerAttribute: "name", 
          idAttribute: "id", 
          label: t('product_admin_general_column_beer_style'), 
          readerAttributeValue: "id", 
          writerAttribute: "beerStyleId", 
          customReaderWriterAttribute: "id", 
          name: t('beer_style_label_name'), 
          floatingLabelText: t('product_admin_general_column_beer_style'), 
          isImmutable: true, 
          value: get(selectedProduct, 'beerStyle'), 
          onChange: this._onChangeDropDownItem, 
          onEnter: this.__onEnterPress}
        ),
        React.createElement(FormGroupTextFieldSuggested, {
          operationsHolder: contextHolder, 
          items: PRODUCT_CATEGORIES, 
          readerAttribute: "displayText", 
          readerAttributeValue: "category", 
          writerAttribute: "category", 
          name: t('category'), 
          value: currentSelectedCategoryValue, 
          label: t('product_admin_category'), 
          isImmutable: true, 
          onChange: this._onChangeDropDownItem, 
          onEnter: this.__onEnterPress}
        ),
        React.createElement(FormGroupTextfield, {
          operationsHolder: contextHolder, 
          readerAttribute: "volume", 
          additionalValidation: inputValue =>
            NumberUtils.isNumber(inputValue)
              ? ''
              : t('product_admin_general_must_be_a_number'), 
          name: t('volume'), 
          value: selectedProduct, 
          label: `${t('volume')} ${unitNameWhitParenthesis}`, 
          isRelaxedText: true, 
          isDecimalFormat: true, 
          decimalDigits: AMOUNT_DECIMALS, 
          isEditMode: isEditMode, 
          onEnter: this._onEnterPress}
        )
      ];

      return (
        React.createElement("div", {className: "brewhouse-view"}, 
          React.createElement(AdminScaffolding, {
            moduleName: "ADMIN_PRODUCT", 
            title: t('product_admin_general_title'), 
            messages: messages, 
            contextHolder: contextHolder, 
            value: selectedProduct, 
            fetchItems: this.fetchProducts, 
            headerFields: formFieldsEl, 
            onAdd: this._onAddProduct, 
            onChange: this._onChangeProducts, 
            onCancel: this._onCancel, 
            onDelete: this._onDeleteProduct, 
            addEnterKeyDown: this._addEnterKeyDown, 
            additionalButtons: additionalButtons, 
            breadcrumb: this._getBreadcrumbLinks()
          }, 
            React.createElement(AdminScaffoldingTable, {
              headerActiveFilters: this.state.headerActiveFilters, 
              onRowSelection: this._onRowSelection, 
              value: selectedProduct, 
              sortByColumn: ['name'], 
              filteredColumns: [
                'name',
                'beerStyle.name',
                'volumeWithUnit',
                'amountItems'
              ], 
              displayAttributes: [
                'name',
                {
                  name: 'beerStyle',
                  getHTML: this._getWrapperColor
                },
                'displayCategory',
                'volumeWithUnit',
                {
                  name: 'iconsFull',
                  getHTML: this._getStampsIcons.bind(this)
                },
                'amountItems'
              ], 
              columnNames: [
                t('product_admin_general_column_name'),
                t('product_admin_general_column_beer_style'),
                t('product_admin_general_column_category'),
                t('product_admin_general_column_volume'),
                t('product_admin_general_column_icons'),
                t('product_admin_general_column_amount_items')
              ]
            }, 
              products
            )
          )
        )
      );
    }
  }
});

function filterBeerStyleEnable(beerStyles) {
  return filter(beerStyles, beerStyle => get(beerStyle, 'enable') === true || get(beerStyle, 'enable') === undefined);
}

module.exports = ProductsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ProductsAdmin/ProductsAdmin.js
 **/